import { boot } from 'quasar/wrappers'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import messages, { LanguageChoice, MessageSchema } from '../i18n'
import { bootErrorMessage } from './error/bootErrorMessage'

export default boot(async ({ app }: { app: any }) => {
  try {
    // Import Vue I18n
    const i18n = createI18n<[MessageSchema], LanguageChoice>({
      legacy: false,
      locale: 'en_US',
      fallbackLocale: 'en_US',
      messages,
    })
    app.use(i18n)

    // Import Pinia
    app.use(createPinia())
  } catch (error) {
    bootErrorMessage(error, { stage: 'plugins' })
  }
})
